import utils from './utils'
import price from './price'
import {
  split,
  toNumber,
  divide,
  isInteger,
  isNaN,
  toString,
  toInteger,
  isString,
  isNumber,
  round
} from 'lodash'

// 头像黑名单，用于部分域名的头像跨域有问题，直接用默认头像
const avatar_blackList = ['wx.qlogo.cn']

function toDemotion(value, rate = 100) {
  let num = toNumber(value)
  num = isNaN(num) ? 0 : num
  return round(divide(num, rate), 2)
}

function isInBlackList(url_hostname) {
  if (url_hostname) {
    const url_match = avatar_blackList.filter(val => val === url_hostname)
    return url_match.length > 0
  } else {
    return false
  }
}
export default function install(Vue) {
  const isSupportWebp = utils.supportWebp()
  Vue.filter('viewImage', (value, width, height, type, zoom = 1) => {
    let img = ''
    const imgType = type || 'jpg'
    if (value) {
      if (isSupportWebp) {
        img = utils.imagePreview(value, width * zoom, height * zoom, 'webp')
      } else {
        img = utils.imagePreview(value, width * zoom, height * zoom, type)
      }
    }
    return img
  })
  // 最后一个参数表示，如果当前value在黑名单中，则替换为该值
  Vue.filter('avatar', (value, width, height, type, filter_avatar) => {
    let img = ''
    const imgType = type || 'jpg'
    if (value) {
      if (filter_avatar) {
        const url = value.match(
          /((?:\w+\.){2}(?:cn|top|com\.cn|com\.tw|com))/
        )[1]
        if (isInBlackList(url)) {
          value = filter_avatar
        }
      }
      if (isSupportWebp) {
        img = utils.imagePreview(value, width, height, 'webp')
      } else {
        img = utils.imagePreview(value, width, height, type)
      }
      return img
    } else {
      return require('../assets/images/avatar.png')
    }
  })
  // 认证育儿师默认头像
  Vue.filter('avatarCert', (value, width, height, type, filter_avatar) => {
    // let img = ''
    const imgType = type || 'jpg'
    if (value) {
      if (filter_avatar) {
        const url = value.match(
          /((?:\w+\.){2}(?:cn|top|com\.cn|com\.tw|com))/
        )[1]
        if (isInBlackList(url)) {
          value = filter_avatar
        }
      }
      // if (isSupportWebp) {
      //     img = utils.imagePreview(value, width, height, 'webp')
      // } else {
      //     img = utils.imagePreview(value, width, height, type)
      // }
      return value
    } else {
      return require('../assets/images/avatar_cert@3x.png')
    }
  })
  // 育儿顾问默认头像
  Vue.filter('avatarAdvi', (value, width, height, type, filter_avatar) => {
    let img = ''
    const imgType = type || 'jpg'
    if (value) {
      if (filter_avatar) {
        const url = value.match(
          /((?:\w+\.){2}(?:cn|top|com\.cn|com\.tw|com))/
        )[1]
        if (isInBlackList(url)) {
          value = filter_avatar
        }
      }
      // if (isSupportWebp) {
      //     img = utils.imagePreview(value, width, height, 'webp')
      // } else {
      //     img = utils.imagePreview(value, width, height, type)
      // }
      img = value
      return img
    } else {
      return require('../assets/images/avatar_advi@3x.png')
    }
  })
  Vue.filter('avatarComment', (value, width, height, type, filter_avatar) => {
    let img = ''
    const imgType = type || 'jpg'
    if (value) {
      if (filter_avatar) {
        const url = value.match(
          /((?:\w+\.){2}(?:cn|top|com\.cn|com\.tw|com))/
        )[1]
        if (isInBlackList(url)) {
          value = filter_avatar
        }
      }
      if (isSupportWebp) {
        img = utils.imagePreview(value, width, height, 'webp')
      } else {
        img = utils.imagePreview(value, width, height, type)
      }
      return img
    } else {
      return require('@/assets/images/avatar_comment@3x.png')
    }
  })
  // Vue.filter('attrs', (value, key) => {
  //     let str = ''
  //     if (value === 'is_matron' && key === 1) {
  //         str = '月嫂'
  //     } else if (value === 'is_touch' && key === 1) {
  //         str = '抚触'
  //     } else if (value === 'is_lact' && key === 1) {
  //         str = '催乳'
  //     } else if (value === 'is_mas' && key === 1) {
  //         str = '小儿推拿'
  //     } else if (value === 'is_lanugo' && key === 1) {
  //         str = '理胎发'
  //     } else if (value === 'is_pos' && key === 1) {
  //         str = '回乳'
  //     } else if (value === 'is_bmg' && key === 1) {
  //         str = '母乳喂养指导'
  //     } else if (value === 'is_par' && key === 1) {
  //         str = '育儿理发'
  //     }
  //     return str
  // })
  Vue.filter('priceNum', value => {
    let str = ''
    if (value >= 0) {
      str = value / 100
    }
    return str
  })
  Vue.filter('percentNum', value => {
    let f = value ? parseFloat(value) : 0
    if (isNaN(f)) {
      return ''
    }
    f = Math.round(f * 10000) / 100
    return `${f}%`
  })

  Vue.filter('price', price)

  Vue.filter('price1', value => {
    return toDemotion(value)
  })
  Vue.filter('distance', value => {
    return toDemotion(value, 1000)
  })
  Vue.filter('priceRange', item => {
    return item && item.minPrice != item.maxPrice ? '起' : null
  })

  Vue.filter('integer', num => {
    const n = toInteger(num)
    const YW = 10000
    let str = ''
    if (n >= YW) {
      const sz = divide(n, YW)
      const ir = toInteger(sz)
      str = `${ir}w${isInteger(sz) ? '' : '+'}`
    }

    return str || n
  })

  let outZero = function f(str) {
    if (
      str.substr(str.length - 1, 1) == '.' ||
      (str.substr(str.length - 1, 1) == 0 && str.indexOf('.') > -1)
    ) {
      str = str.substr(0, str.length - 1)
      return outZero(str)
    } else if (str.indexOf('.') == -1 || str.substr(str.length - 1, 1) != 0) {
      return str
    }
  }
  Vue.filter('distance2km', value => {
    value = (+value / 1000).toFixed(2, 10) + ''
    return outZero(value)
  })
}
